import { Building2, GraduationCap } from "lucide-react";
import { CLINIC } from "@/constants/clinic";

export const About = () => (
  <section id="about" className="bg-white py-20 lg:py-28">
    <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-12 items-center">
      <img src="/images/hero.jpg" alt="Blood sugar check with a glucometer" className="lg:col-span-5 w-full h-80 lg:h-[440px] object-cover rounded-3xl" data-testid="about-image" />
      <div className="lg:col-span-7 lg:pl-8">
        <p className="text-sm font-semibold uppercase tracking-widest text-secondary">About the doctor</p>
        <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-[#1A252C]" data-testid="about-title">{CLINIC.doctor}</h2>
        <p className="mt-2 text-muted-foreground">{CLINIC.title}</p>
        <p className="mt-6 text-base text-muted-foreground leading-relaxed max-w-2xl">
          Dr. Saurabh Agarwal is a Consultant Physician and Diabetologist in Lucknow, specialising in comprehensive diabetes
          management, metabolic disorders, thyroid diseases, hypertension and adult internal medicine. He combines
          evidence-based medical practice with personalised patient care.
        </p>
        <p className="mt-8 flex items-center gap-2 text-sm font-semibold text-[#1A252C]"><GraduationCap className="h-4 w-4 text-secondary" /> Qualifications</p>
        <div className="mt-3 flex flex-wrap gap-2" data-testid="about-qualifications">
          {CLINIC.qualifications.map((q) => (
            <span key={q} className="rounded-full bg-accent text-primary px-3 py-1 text-sm font-medium">{q}</span>
          ))}
        </div>
        <p className="mt-8 flex items-center gap-2 text-sm font-semibold text-[#1A252C]"><Building2 className="h-4 w-4 text-secondary" /> Currently at</p>
        <div className="mt-3 rounded-2xl border border-primary/15 bg-accent/50 px-5 py-4" data-testid="about-current-position">
          <p className="font-semibold text-[#1A252C]">HealthCity Vistaar Multi-Speciality Hospital, Lucknow</p>
          <p className="mt-1 text-muted-foreground">Department of Endocrinology, Diabetes &amp; Metabolism</p>
        </div>
        <p className="mt-8 flex items-center gap-2 text-sm font-semibold text-[#1A252C]"><Building2 className="h-4 w-4 text-secondary" /> Previously at</p>
        <ul className="mt-3 space-y-2" data-testid="about-experience">
          {CLINIC.experience.map((e) => <li key={e} className="text-muted-foreground">{e}</li>)}
        </ul>
      </div>
    </div>
  </section>
);
